import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'

interface QuotesInitialStateType {
  data: [{
    quote: string,
    author: string,
    backgroundImage: string
  }]
  loading: boolean
  status: number | null
  errorStatus: number | null
}

const initialState: QuotesInitialStateType = {
  data: [{
    quote: "",
    author: "",
    backgroundImage: ""
  }],
  loading: false,
  status: null,
  errorStatus: null
}

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const getQuotes = createAsyncThunk('QuotesSlice/getQuotes', async (_, thunkApi) => {
  try {
    const response = await axios.get(apiUrl + '/pages/quotes')
    const data = await response.data.data
    return thunkApi.fulfillWithValue(data)
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status)
  }
})

const QuotesSlice = createSlice({
  name: "QuotesSlice",
  initialState,
  reducers: {
    getValue: (state, action) => {
      state.data = action.payload
    },
    resetValue: (state) => {
      state.data = [{ quote: "", author: "", backgroundImage: "" }]
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getQuotes.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getQuotes.fulfilled, (state, action) => {
      state.data = action.payload
    })
    builder.addCase(getQuotes.rejected, (state, action) => {
      state.errorStatus = action.payload as number
    })
    builder.addMatcher(isAnyOf(
      getQuotes.fulfilled, getQuotes.rejected), (state) => {
        state.loading = false
      })
  }
})

const QuotesThunks = {
  getQuotes,
}

export const QuotesServices = {
  ...QuotesThunks,
  actions: QuotesSlice.actions,
}

const QuotesReducer = QuotesSlice.reducer
export default QuotesReducer